import RequestPermissionButton from './RequestPermissionButton';

export default RequestPermissionButton;
